import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/home.vue')
  },
  {
    path: '/login',
    name:'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/WaterAndElectricityManagement',
    name: 'WaterAndElectricityManagement',
    component: () => import(/* webpackChunkName: "about" */ '../views/WaterAndElectricityManagement.vue')
  },
  {
    path: '/ComputerRoomManagement',
    name: 'ComputerRoomManagement',
    component: () => import(/* webpackChunkName: "about" */ '../views/ComputerRoomManagement.vue')
  },
  {
    path: '/SolarEnergy',
    name: 'SolarEnergy',
    component: () => import(/* webpackChunkName: "about" */ '../views/SolarEnergy.vue')
  },
  {
    path: '/AirConditioningManagement',
    name: 'AirConditioningManagement',
    component: () => import(/* webpackChunkName: "about" */ '../views/AirConditioningManagement.vue')
  },
  {
    path: '/trend',
    name: 'trend',
    component: () => import(/* webpackChunkName: "about" */ '../views/trend.vue')
  },
  {
    path: '/ElevatorManagement',
    name: 'ElevatorManagement',
    component: () => import(/* webpackChunkName: "about" */ '../views/ElevatorManagement.vue')
  },
  {
    path: '/OperationMaintenance',
    name: 'OperationMaintenance',
    component: () => import(/* webpackChunkName: "about" */ '../views/OperationMaintenance.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// router.beforeEach((to,from,next) => {
//   if(localStorage.getItem('token') || to.name == 'login' || to.name == 'index'){
//     next()
//   }else{
//     // return {name:'login'}
//     next('/login')
//   }
// })

export default router
